import React from "react";
import { Link } from "react-router-dom";
import copy from "../lib/copy";
import services from "../lib/services";

const Footer = () => (
  <footer className="foot">
    <div className="shell">
      <div className="grid">
        <div className="lead-block">
          <img src="/brand/vitalis-logo.png" alt={copy.brand} className="footer-logo" />
          <p>{copy.positioning}</p>
        </div>

        <div>
          <h5>Capabilities</h5>
          {services.slice(0, 6).map((s) => (
            <Link key={s.slug} to={`/services/${s.slug}`}>{s.title}</Link>
          ))}
        </div>

        <div>
          <h5>Studio</h5>
          <Link to="/services">All services</Link>
          <Link to="/markets">Sectors</Link>
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
          <a href={`mailto:${copy.contact.email}`}>{copy.contact.email}</a>
        </div>
      </div>

      <div className="colophon">
        <span>© {new Date().getFullYear()} {copy.longName}. All rights reserved.</span>
        <span>{copy.hq.city}, {copy.hq.country}</span>
      </div>
    </div>
  </footer>
);

export default Footer;
